import { MuiTheme, color, createStyles, makeStyles } from '@kis-technologies/kis-ui';

export const useStyles = (props?: { isOpen: boolean }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      activitylogHeading: {
        padding: '24px 40px',
        justifyContent: 'space-between',
        background: 'transparent',
        display: 'flex',
        height: '100px',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
          flexDirection: 'column',
          height: 'auto'
        },
        [theme.breakpoints.only('sm')]: {
          alignItems: 'baseline',
          gap: '24px',
          padding: '24px 30px'
        },
        [theme.breakpoints.only('xs')]: {
          gap: '16px',
          justifyContent: 'center',
          padding: '16px 24px 0'
        }
      },
      activitylogText: {
        fontSize: '40px',
        fontWeight: 600,
        lineHeight: '1',
        [theme.breakpoints.only('xs')]: {
          fontSize: '32px'
        }
      },
      activitylogOuterBox: {
        flex: 1,
        minHeight: 0,
        background: 'transparent',
        padding: '0px 40px 0px',
        overflow: 'visible',
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.down('sm')]: {
          padding: '5px 20px 20px'
        }
      },
      activitylogHeaders: {
        lineHeight: '1.13 !important',
        fontSize: '16px !important'
      },
      activitylogTableRows: {
        height: '70px'
      },
      activityRefreshEventButton: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'end'
      },
      filtersFieldsFlexBox: {
        gap: '16px',
        [theme.breakpoints.down('md')]: {
          flexDirection: 'column',
          gap: 0
        }
      },
      filtersFieldBox: {
        height: '110px',
        minHeight: '110px'
      },
      filtersFieldLabel: {
        fontSize: '16px',
        fontWeight: 600,
        marginBottom: '10px',
        padding: '0 16px'
      },
      filtersInputField: {
        width: '262px',
        borderRadius: '50px',
        height: '45px',
        color: 'grey',
        '& .MuiOutlinedInput-notchedOutline': {
          borderWidth: '1px !important'
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: color.BLACK
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: color.BLACK
        }
      },
      datePickerContainer: {
        '& .react-datepicker__close-icon': {
          padding: '0 12px 0 0'
        },
        '& .react-datepicker__close-icon::after': {
          backgroundColor: '#F46D2E'
        },
        '& .react-datepicker__day--selected': {
          backgroundColor: '#F46D2E',
          color: 'white'
        },
        '& .react-datepicker__day--today': {
          backgroundColor: '#F46D2E',
          color: 'white'
        },
        '& .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected':
          {
            backgroundColor: '#F46D2E',
            color: 'white'
          },
        '& .react-datepicker__today-button': {
          color: '#F46D2E'
        },
        '& .react-datepicker': {
          fontFamily: 'inherit'
        }
      },
      /* Shift left so the date picker is right aligned with the input field */
      rightDatePickerContainer: {
        '& .react-datepicker': {
          left: '-84px',
          [theme.breakpoints.down('md')]: {
            left: '0px'
          }
        }
      },
      datePickerInput: {
        fontSize: '16px',
        backgroundColor: 'white',
        border: 'solid 0.1em #cbd4c9',
        width: '262px',
        height: '45px',
        borderRadius: '50px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      },
      datePickerComponent: {
        width: '360px',
        height: '60px',
        borderRadius: '15px',
        padding: '12px'
      },
      '.my-datepicker-wrapper .react-datepicker-wrapper': {
        /* add your custom styles here */
        // border: '1px solid red'
      },
      filtersResetButtonBox: {
        justifyContent: 'flex-end',
        [theme.breakpoints.down('sm')]: {
          justifyContent: 'center'
        }
      },
      filterOptions: {
        padding: '0px 40px',
        background: 'transparent',
        display: 'flex',
        height: '60px',
        alignItems: 'center'
      },
      activitylogOptions: {
        padding: '0px 40px',
        background: 'transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        [theme.breakpoints.only('xs')]: {
          justifyContent: 'center',
          gap: '8px',
          padding: '24px 0px 0px'
        }
      },
      buttonStyl: {
        '&.MuiChip-outlined .MuiChip-deleteIcon': {
          color: 'white'
        }
      },
      footer: {
        width: '100%',
        overflow: 'hidden',
        padding: '0px 40px'
      },
      total: {
        float: 'right',
        fontSize: '20px',
        padding: '24px 0 0',
        fontWeight: 900,
        margin: 0
      },
      body: {
        overflow: props && props.isOpen ? 'hidden' : 'auto'
      }
    })
  );
